/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.TIME = function () {

    this.resourceKey = 'Survey.Sidebar.Time';
    this.jsonType = 'TIME';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

};